export default __webpack_public_path__ + "static/fingerprint-bg-mobile-398449d68c6c8d0ab351b31bf4809219.svg";